// PI1 Form content: utilized throughout the PI1 form

export const usStates = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

export const patRelOptions = [
  { name: "Self", val: 6 },
  { name: "Spouse/Partner", val: 1 },
  { name: "Child", val: 4 },
  { name: "Grandchild", val: 7 },
  { name: "Parent", val: 2 },
  { name: "Grandparent", val: 3 },
  { name: "Sibling", val: 5 },
  { name: "Other", val: 9 },
];

export const emailIsntUniqText =
  "The email address you entered already exists from a previous application. Please apply using a different valid email address.";

export const emailAPIUniqErrorText =
  "Unable to check, currently. Please retype your email in a few moments.";

export const pi1LegalProcTextUpdates = [
  "IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT",
  "To help the government fight the funding of terrorism and money laundering activities, Federal law requires all financial institutions to obtain, verify, and record information that identifies each person who opens an account.",
  "What this means for you: When you open an account, or when you are added to an existing account, we will ask for your name, permanent physical street address, date of birth, and other information, which may include social security number or TIN, that will allow us to identify you. We may also ask to see your driver's license or other identifying documents. You may also be asked to provide such information at other times upon request of the Bank.  We will accept a post office box only as a mailing address.",
];

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');